export default {
  // キャンペーン ID
  id: "7UXh6cTG",
  // 画面タイトル
  title: "カルピスｘドラゴンボールコラボキャンペーン",
  // カラーテーマ
  colorTheme: {
    primary: "#003a9d",
    secondary: "#b0bec5",
    accent: "#b900b9",
    error: "#b71c1c",
    info: "#eeeeee",
    success: "#00b900",
    warning: "#FFC107",
  },
  // 背景色
  backgroundColor: "#003399",
  // テキストカラー
  textColor: "#ffffff",
  // フォントスタイル
  fontStyle:
    'font-family:"Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif',
  // 画像ファイル名
  imageName: {
    header: {
      // バナー画像
      bannerMain: "top_banner.jpg",
    },
    footer: {
      information: "footer_banner.jpg",
      faq: "footer_faq.jpg",
      showFaq: "footer_faq1.jpg",
      hideFaq: "footer_faq2.jpg",
      requirements: "footer_requirements.jpg",
      showRequirements: "footer_requirements1.png",
      hideRequirements: "footer_requirements2.png",
    },
    addFriend: {
      // 友だち追加 バナー画像
      bannerAddFriend: "error_addFriend.jpg",
      // 友だち追加ボタン
      addFriendButton: "error_addFriendButton.png",
    },
    campaign: {
      bannerMain: "top_banner1.jpg",
      // 説明バナー画像
      bannerDesc: "top_banner2.jpg",
      triangle: "triangle.jpg",
      // LINEポイントコネクト 選択ボタン画像
      buttonSelectLINE: "top_retrieveButton.png",
      // ログインボタン画像
      buttonLogin: "top_oubo.png",
      // 無効シリアルコード ポップアップ画像
      popupInvalidSerialCode: "error_invalidSerialCode.jpg",
      // 閉じる
      popupClose: "error_close.png",
      products: "top_banner3.jpg",
      participate: "top_banner4.jpg",
    },
    collabCourses: {
      collaboCourseHeader: "collaboCourse_pageTitle.jpg",
      collaboPageGoToTopPage: "collaboCourse_toTopPage.png",
    },
    lineCourses: {
      lineCourseHeader: "lineCourse_pageTitle.jpg",
      collaboPageGoToTopPage: "lineCourse_toTopPage.png",
    },
    requestHistory: {
      requestHistoryHeader: "requestHistory_pageTitle.jpg",
      // 配送情報
      deliveryInfo: "requestHistory_inputInformationButton.png",
      goToTopPage: "requestHistory_toTopPage.png",
    },
    myPage: {
      bunner_01: "top_banner.jpg",
      bunner_02: "mypageCollection_image1.jpg",
      bunner_03: "4.jpg",
      bunner_04: "mypageWon_banner1.jpg",
      button_inKindCourse: "mypageCollection_toInKindPage.png",
      button_LINECourse: "mypageCollection_toLinePointPage.png",
      button_toCampaignPage: "mypageCollection_toTopPage.png",
      button_toCampaignPageWon: "mypageWon_toTopPage.png",
      button_requestHistory: "mypageCollection_toRequestHistoryPage.png",
      button_collectionHistory: "mypageCollection_toCollectionHistoryPage.png",
      popup_collect: "mypageWon_retrieveImage.jpg",
      popup_collectWon: "mypageCollection_retrieveImage.jpg",
      popupClose: "mypageCollection_close.png",
    },
    requestDetailPage: {
      bunner_01: "top_banner.jpg",
      pageTitle: "requested_pageTitle.jpg",
      button_request: "requested_requestButton.png",
      button_back: "requested_backButton.png",
      button_toCampaignPage: "requested_toTopPage.png",
    },
    resultPage: {
      bunner_01: "top_banner.jpg",
      button_toCampaignPage: "win_toTopPage.png",
      button_toInputInfoPage: "win_inputInformationButton.png",
      button_lose_toCampaignPage: "lose_toTopPage.png",
    },
    collectHistoryPage: {
      bunner_01: "top_banner.jpg",
      pageTitle: "collectionHistory_pageTitle.jpg",
      button_toCampaignPage: "collectionHistory_toTopPage.png",
    },
    expiredPage: {
      bunner: "top_banner.jpg",
      teaser: "teaserEnd_teaserImage.jpg",
      closed: "teaserEnd_endImage.jpg",
    },
    errorPopup: {
      addFriend: "error_addFriend.jpg",
      requestUnblock: "error_pointConnectErrorBlocked.jpg",
      systemError: "error_error.jpg",
      invalidSerialCode: "error_invalidSerialCode.jpg",
      usedSerialCode: "error_usedSerialCode.jpg",
      errorLinePoint: "error_pointConnectError.jpg",
      invalidPeriod: "error_invalidPeriod.jpg",
      goToTopPage: "error_toTopPage.png",
      popupClose: "error_close.png",
    },
    courses: {
      prd: {
        10: {
          active: "lineCourse_product1.png",
          inactive: "lineCourse_product1Inactive.png",
          detail: "lineCourse_requested_product1.jpg",
        },
        11: {
          active: "lineCourse_product2.png",
          inactive: "lineCourse_product2Inactive.png",
          detail: "lineCourse_requested_product2.jpg",
        },
        12: {
          active: "lineCourse_product3.png",
          inactive: "lineCourse_product3Inactive.png",
          detail: "lineCourse_requested_product3.jpg",
        },
        13: {
          active: "collaboCourse_productSelect1.png",
          inactive: "collaboCourse_productSelect1Inactive.png",
          detail: "collaboCourse_requested_product1.jpg",
        },
        14: {
          active: "collaboCourse_productSelect2.png",
          inactive: "collaboCourse_productSelect2Inactive.png",
          detail: "collaboCourse_requested_product2.jpg",
        },
        15: {
          active: "collaboCourse_productSelect3.png",
          inactive: "collaboCourse_productSelect3Inactive.png",
          detail: "collaboCourse_requested_product3.jpg",
        },
        16: {
          active: "collaboCourse_productSelect4.png",
          inactive: "collaboCourse_productSelect4Inactive.png",
          detail: "collaboCourse_requested_product4.jpg",
        },
        17: {
          active: "collaboCourse_productSelect5.png",
          inactive: "collaboCourse_productSelect5Inactive.png",
          detail: "collaboCourse_requested_product5.jpg",
        },
        18: {
          active: "collaboCourse_productSelect6.png",
          inactive: "collaboCourse_productSelect6Inactive.png",
          detail: "collaboCourse_requested_product6.jpg",
        },
      },
      stg: {
        10: {
          active: "lineCourse_product1.png",
          inactive: "lineCourse_product1Inactive.png",
          detail: "lineCourse_requested_product1.jpg",
        },
        11: {
          active: "lineCourse_product2.png",
          inactive: "lineCourse_product2Inactive.png",
          detail: "lineCourse_requested_product2.jpg",
        },
        12: {
          active: "lineCourse_product3.png",
          inactive: "lineCourse_product3Inactive.png",
          detail: "lineCourse_requested_product3.jpg",
        },
        13: {
          active: "collaboCourse_productSelect1.png",
          inactive: "collaboCourse_productSelect1Inactive.png",
          detail: "collaboCourse_requested_product1.jpg",
        },
        14: {
          active: "collaboCourse_productSelect2.png",
          inactive: "collaboCourse_productSelect2Inactive.png",
          detail: "collaboCourse_requested_product2.jpg",
        },
        15: {
          active: "collaboCourse_productSelect3.png",
          inactive: "collaboCourse_productSelect3Inactive.png",
          detail: "collaboCourse_requested_product3.jpg",
        },
        16: {
          active: "collaboCourse_productSelect4.png",
          inactive: "collaboCourse_productSelect4Inactive.png",
          detail: "collaboCourse_requested_product4.jpg",
        },
        17: {
          active: "collaboCourse_productSelect5.png",
          inactive: "collaboCourse_productSelect5Inactive.png",
          detail: "collaboCourse_requested_product5.jpg",
        },
        18: {
          active: "collaboCourse_productSelect6.png",
          inactive: "collaboCourse_productSelect6Inactive.png",
          detail: "collaboCourse_requested_product6.jpg",
        },
      },
      dev: {},
    },
  },
  // 参加方法文言
  participateText: "キャンペーン参加方法<br />詳細はこちら",
  courseText: "ドラゴンボールコース、LINEコース<br />いずれかのコースで当選済みとなる<br />キャンペーンです。<br />本キャンペーンの当選は1回までとなります。",

  // 外部リンク
  links: [],
  courseGroups: {
    prd: {
      line: { id: 3 },
      collab: { id: 4 }
    },
    stg: {
      line: { id: 5 },
      collab: { id: 6 }
    },
    dev: {
      line: { id: 0 },
      collab: { id: 0 }
    },
  },
  // 友だち
  addFriend: {
    baseUrl: {
      prd: "https://rd.ca-link.jp/r",
      stg: "https://stg-rd.ca-link.jp/r",
      dev: "https://dev-rd.ca-link.jp/r",
    },
    text: "友だち追加されていないか、ブロック状態のため処理を継続できませんでした。",
  },
  // リダイレクター
  redirector: {
    code: {
      prd: "nez",
      stg: "nez",
      dev: "",
    },
  },
};
